import { ICellRendererParams } from "ag-grid-community";
import { ShieldAlert } from "lucide-react";
import React, { useMemo } from "react";

import { IgTooltip } from "@intelligems/ig-theme";
import {
  OrganizationSummaryDto,
  StripeSubscriptionStatus,
} from "@intelligems/ig-types";
import { Grid, useTheme } from "@mui/material";
import { AgencyIcon } from "@src/features/admin/components/Icons/AgencyIcon";
import { BillingAutoScaleIcon } from "@src/features/admin/components/Icons/BillingAutoScaleIcon";
import { BillingWarningIcon } from "@src/features/admin/components/Icons/BillingWarningIcon";
import { StatusBadge } from "@src/features/admin/components/Icons/StatusBadge";
import {
  getHasStripeBillingMethod,
  getStatusFromAdminOrg,
} from "@src/features/admin/components/utils";

export const IconColumn = (
  params: ICellRendererParams<OrganizationSummaryDto, boolean>
) => {
  const theme = useTheme();
  const status: StripeSubscriptionStatus = useMemo(() => {
    return getStatusFromAdminOrg(params.data);
  }, [params.data]);

  const hasBilling = useMemo(() => {
    if (!params.data) {
      return true;
    }

    return getHasStripeBillingMethod(params.data.stripeSubscriptionSummaries);
  }, [params.data]);

  if (!params.data) {
    return null;
  }

  return (
    <Grid
      container
      columnSpacing={1}
      alignItems={"center"}
      justifyContent={"end"}
    >
      {hasBilling ? null : (
        <Grid item sx={{ marginTop: "5px" }}>
          <IgTooltip title={"Payment Method Missing"}>
            <ShieldAlert color={theme.igIconColors.error} />
          </IgTooltip>
        </Grid>
      )}
      {params.data.isInstalled ? null : (
        <Grid item sx={{ marginTop: "5px" }}>
          <BillingWarningIcon />
        </Grid>
      )}
      {params.data.agencies.length ? (
        <Grid item>
          <AgencyIcon />
        </Grid>
      ) : null}
      <Grid item>
        <BillingAutoScaleIcon
          autoScale={params.data.stripeSubscriptionSummaries.some(
            (s) => s.autoScale
          )}
        />
      </Grid>

      <Grid item>
        <StatusBadge status={status} />
      </Grid>
    </Grid>
  );
};
